var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var _a, _b;
import { h, Fragment } from "preact";
import { useState, useRef } from "preact/hooks";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "unfetch/polyfill";
import VideoDetailsModal from "../VideoDetailsModal";
import DisplayModal from "../DisplayModal";
import Spinner from "../Spinner";
import VideoPeelLogo from "../VideoPeelLogo";
import { PluginType } from "../../types/Plugin.interface";
import { vpPluginContainer, vpPluginPlaylistContainer } from "./PluginContainer.css";
import Carousel from "../Carousel";
import List from "../List";
import Gallery from "../Gallery";
import Playlist from "../Playlist";
import { DisplayTypes } from "../../types/Display.interface";
import MediaDetailsForm from "../DetailsForm/Form";
var getQueryParams = function (search) {
    var result = {};
    var params = search.substr(1);
    var queryParamArray = params.split('&');
    queryParamArray.forEach(function (queryParam) {
        var item = queryParam.split("=");
        result[item[0]] = decodeURIComponent(item[1]);
    });
    return result;
};
// Can PluginType.PIP be removed?
var PluginComponentMap = (_a = {},
    _a[PluginType.CAROUSEL] = Carousel,
    _a[PluginType.LIST] = List,
    _a[PluginType.PLAYLIST] = Playlist,
    _a[PluginType.GALLERY] = Gallery,
    _a[PluginType.PIP] = Carousel,
    _a);
var PluginContainerStyleMap = (_b = {},
    _b[PluginType.CAROUSEL] = vpPluginContainer,
    _b[PluginType.LIST] = vpPluginContainer,
    _b[PluginType.PLAYLIST] = vpPluginPlaylistContainer,
    _b[PluginType.GALLERY] = vpPluginContainer,
    _b[PluginType.PIP] = vpPluginContainer,
    _b);
var PluginContainer = function (_a) {
    var _b, _c;
    var _d = _a.data, data = _d === void 0 ? {} : _d, isLoading = _a.isLoading, orgId = _a.orgId;
    var videoPlayerRef = useRef(null);
    var _e = useState([]), itemList = _e[0], setItemList = _e[1];
    var _f = useState(""), activeVideo = _f[0], setActiveVideo = _f[1];
    var _g = useState(""), activeImage = _g[0], setActiveImage = _g[1];
    var _h = useState({}), activeDetails = _h[0], setActiveDetails = _h[1];
    var _j = useState(false), isModalOpen = _j[0], setIsModalOpen = _j[1];
    var _k = useState(false), isDetailsOpen = _k[0], setIsDetailsOpen = _k[1];
    var queryParams = getQueryParams(window.location.search);
    var isPreview = queryParams.isPreview;
    var isPreviewTrue = isPreview === 'true';
    if (isLoading) {
        return h(Spinner, null);
    }
    if (!data ||
        !Object.keys(data).length ||
        !((_c = (_b = data) === null || _b === void 0 ? void 0 : _b.content) === null || _c === void 0 ? void 0 : _c.length)) {
        return null;
    }
    var shouldEdit = !(data.role === "Viewer") && isPreviewTrue;
    var pluginType = data.type;
    var pluginStyles = data.styles;
    var PluginComponent = PluginComponentMap[pluginType];
    var pluginContainerStyle = PluginContainerStyleMap[pluginType];
    var autoplay = pluginType === PluginType.PLAYLIST && (pluginStyles === null || pluginStyles === void 0 ? void 0 : pluginStyles.autoplay);
    var displayItem = function (item) {
        var type = item[0], data = item[1];
        if (type === DisplayTypes.VIDEO) {
            setActiveVideo(data);
            setActiveImage("");
        }
        else if (type === DisplayTypes.IMAGE) {
            setActiveImage(data);
            setActiveVideo("");
        }
    };
    var displayNextItem = function (list) {
        if (list.length) {
            var first = list[0], rest = list.slice(1);
            setItemList(__spreadArray(__spreadArray([], rest, true), [first], false));
            displayItem(first);
        }
    };
    var displayPreviousItem = function (list) {
        if (list.length) {
            var currentIndex = list.length - 1;
            var newList = __spreadArray([list[currentIndex]], list.slice(0, currentIndex), true);
            setItemList(newList);
            displayItem(newList[currentIndex]);
        }
    };
    var onClickPlayHandler = function (type, param) {
        if (type === DisplayTypes.IMAGE) {
            setActiveImage(param);
        }
        else if (type === DisplayTypes.VIDEO) {
            setActiveVideo(param);
        }
        else {
            displayNextItem(param);
        }
    };
    var onVideoEndedHandler = function () {
        if (!autoplay || !itemList.length)
            return;
        displayNextItem(itemList);
    };
    var onClickCloseHandler = function () {
        setActiveVideo("");
        setActiveImage("");
        setItemList([]);
    };
    return (h(Fragment, null,
        h(DisplayModal, { videoPlayerRef: videoPlayerRef, videoUrl: activeVideo, imageUrl: activeImage, showCustomControls: !!itemList.length, onClickCloseHandler: onClickCloseHandler, onClickPreviousHandler: function () { return displayPreviousItem(itemList); }, onClickNextHandler: function () { return displayNextItem(itemList); }, onVideoEndedHandler: onVideoEndedHandler }),
        isDetailsOpen && h(VideoDetailsModal, { videoTitle: activeDetails.title, videoDescription: activeDetails.description, onClickCloseHandler: function () {
                setIsDetailsOpen(false);
                setActiveDetails({});
            }, styles: pluginStyles, open: isDetailsOpen }),
        shouldEdit && isModalOpen && h(MediaDetailsForm, { item: activeDetails, isVideo: activeDetails.contentType === 'video', onClose: function () {
                setIsModalOpen(false);
                setActiveDetails({});
            }, orgId: orgId, isPreview: shouldEdit }),
        h("div", { "data-testid": "plugin-container", className: pluginContainerStyle },
            h(PluginComponent, { onClickPlayHandler: onClickPlayHandler, onOpenDetailsHandler: function (details) {
                    setActiveDetails(details);
                    setIsDetailsOpen(true);
                }, data: data, setIsModalOpen: function (details) {
                    setActiveDetails(details);
                    setIsModalOpen(true);
                }, isPreview: shouldEdit }),
            h(VideoPeelLogo, { data: data }))));
};
export default PluginContainer;
